import { useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"

import type { CustomerLocationCombination } from "@/graphql/codegen/graphql"

interface UseStartCustomerOrderReturn {
  startOrder: (row: CustomerLocationCombination) => void
}

export const useStartCustomerOrder = (): UseStartCustomerOrderReturn => {
  const navigate = useNavigate()

  const startOrder = useCallback(
    (row: CustomerLocationCombination) => {
      navigate({
        to: "/app/orders/$companyId/$shipToLocationId/customer-purchase-orders",
        params: {
          companyId: row.company.companyId,
          shipToLocationId: row.shipToLocation.locationId,
        },
      })
    },
    [navigate]
  )

  return { startOrder }
}
